<template>
  <div class="com-frame" ref="comFrameRef" tabindex="-1" outline="none">
    <div class="inner-wrap">
      <!-- 左侧：分录列表，表头固定 -->
      <div class="left-frame">
        <div class="table-caption">
          分录列表
          <span v-if="focusMode === 'voucher'" class="tag-active">【←→切换面板，按 ↑ ↓ 切换分录组】</span>
        </div>
        <div class="table-wrap" ref="tableWrapRef">
          <table class="voucher-table">
            <thead>
            <tr>
              <th class="col-icon"></th>
              <th width="90" class="text-center">校验结果</th>
              <th width="80">摘要</th>
              <th>科目</th>
              <th width="110">借方金额</th>
              <th width="110">贷方金额</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(row, idx) in voucherTableData"
                :key="idx"
                :class="{ 'active-voucher-group': row.groupIndex === activeGroupIndex }"
                @click="onVoucherRowClick(row)"
            >
              <td class="icon-cell col-icon">
                <i v-if="focusMode === 'voucher' && isGroupFirstRow(row)" class="fa fa-hand-o-right"></i>
              </td>
              <!-- 移除 v-if="isGroupFirstRow(row)"，同组每一行都展示校验结果 -->
              <td class="text-center">
<!--                  <span-->
<!--                      v-if="validationMap.has(row.groupIndex)"-->
<!--                      :class="['validate-tag', validationMap.get(row.groupIndex) ? 'tag-pass' : 'tag-fail']"-->
<!--                  >-->
<!--                    {{ validationMap.get(row.groupIndex) ? '通过' : '不通过' }}-->
<!--                  </span>-->
<!--                <span v-else class="validate-empty">-</span>-->
                <span v-if="validationMap.has(row.groupIndex)">
                  <i v-if="validationMap.get(row.groupIndex)" class="h-icon-success green-color"></i>
                  <i v-else class="h-icon-error red-color"></i>
                </span>
                <span v-else class="validate-empty">-</span>

              </td>
              <td>{{ row.summary }}</td>
              <td>{{ row.subjectName }}</td>
              <td class="text-right">{{ numFormat(row.debitAmount) }}</td>
              <td class="text-right">{{ numFormat(row.creditAmount) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 中间栏：附件列表 + 底部校验按钮区 -->
      <div class="mid-frame">
        <div class="panel-title">
          附件列表
          <span v-if="focusMode === 'attach'" class="tag-active">【←→切换面板，按 ↑ ↓ 切换附件】</span>
        </div>
        <ul class="h-menu menu-custom h-menu-mode-vertical" style="height:calc(100% - 85px);overflow:auto;">
          <li
              v-for="(menuItem, index) in dataList"
              class="h-menu-li h-menu-first-level"
              @click="menuClick(menuItem, index)"
              :ref="el => { if (index === selectedIndex) selectedEl = el }"
          >
            <div :class="'h-menu-show' + ((index === selectedIndex) ? ' h-menu-li-selected' : '')">
              <i
                  v-if="focusMode === 'attach' && index === selectedIndex"
                  class="fa fa-hand-o-right"
                  style="position:absolute;left:8px;"
              ></i>
              <span class="h-menu-show-icon">
                {{ index + 1 }} 、<i :class="menuItem.icon"></i>
              </span>
              <h-tooltip :content="menuItem.title" placement="top-start">
                <span class="h-menu-show-desc">{{ menuItem.title }}</span>
              </h-tooltip>
            </div>
          </li>
        </ul>

        <!-- 底部：每个h‑button外层套div.btn-item，无size属性 -->
        <div class="attach-bottom-btn-wrap">
          <div class="btn-item">
            <h-button color="primary" @click="doValidateAll">校验</h-button>
          </div>
          <div class="btn-item">
            <h-button
                :color="hasPrevInvalid ? 'primary' : null"
                :disabled="!hasPrevInvalid"
                @click="goPrevInvalid"
            >上一个未通过</h-button>
          </div>
          <div class="btn-item">
            <h-button
                :color="hasNextInvalid ? 'primary' : null"
                :disabled="!hasNextInvalid"
                @click="goNextInvalid"
            >下一个未通过</h-button>
          </div>
        </div>
      </div>

      <!-- 右侧：预览区域 -->
      <div class="right-frame">
        <img
            v-if="selectedMenu.type === 'img'"
            :src="selectedMenu.url + '#navpanes=0'"
            title=""
            style="width:100%;height:100%;"
        />
        <iframe
            v-else
            :src="selectedMenu.url + '#navpanes=0'"
            title=""
            style="width:100%;height:100%;border:none;"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoucherAttachmentList",
  props: {
    voucherDetails: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      focusMode: "voucher",
      activeGroupIndex: 0,
      voucherTableData: [],
      dataList: [],
      selectedIndex: 0,
      selectedEl: null,
      selectedMenu: {
        title: "",
        key: "",
        type: "pdf",
        icon: "fa fa-file-pdf-o",
        url: ""
      },
      validationMap: new Map()
    };
  },
  computed: {
    groupIdList() {
      const set = new Set(this.voucherTableData.map(i => i.groupIndex));
      return Array.from(set).sort((a, b) => a - b);
    },
    currentVoucherGroup() {
      return this.voucherTableData.filter(i => i.groupIndex === this.activeGroupIndex);
    },
    currentRawAttach() {
      const groupRows = this.currentVoucherGroup;
      if (!groupRows || groupRows.length === 0) return [];
      return groupRows[0].billList || [];
    },
    invalidGroupList() {
      return this.groupIdList.filter(g => this.validationMap.get(g) === false);
    },
    hasPrevInvalid() {
      if (!this.invalidGroupList.length) return false;
      const currIdx = this.invalidGroupList.indexOf(this.activeGroupIndex);
      return currIdx > 0;
    },
    hasNextInvalid() {
      if (!this.invalidGroupList.length) return false;
      const currIdx = this.invalidGroupList.indexOf(this.activeGroupIndex);
      if (currIdx === -1) return true;
      return currIdx < this.invalidGroupList.length - 1;
    }
  },
  created() {
    this.buildGroupIndex();
    this.loadList();
  },
  mounted() {
    window.addEventListener("keydown", this.handleGlobalKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleGlobalKeyDown);
  },
  watch: {
    voucherDetails: {
      handler() {
        this.buildGroupIndex();
        this.loadList();
        this.validationMap.clear();
      },
      deep: true
    },
    activeGroupIndex() {
      this.loadList();
      this.$nextTick(() => {
        this.scrollVoucherToView();
      });
    }
  },
  methods: {
    // 全量校验所有分录组
    doValidateAll() {
      this.validationMap.clear();
      for (const gIdx of this.groupIdList) {
        const groupRows = this.voucherTableData.filter(r => r.groupIndex === gIdx);
        const debitSum = groupRows.reduce((s, row) => s + Number(row.debitAmount || 0), 0);
        const creditSum = groupRows.reduce((s, row) => s + Number(row.creditAmount || 0), 0);
        let pass = Math.abs(debitSum - creditSum) < 0.001;
        // 调试模拟失败，上线删除
        const mockFailGroup = [1, 3, 11];
        if (mockFailGroup.includes(gIdx)) pass = false;
        this.validationMap.set(gIdx, pass);
      }
    },
    goPrevInvalid() {
      if (!this.hasPrevInvalid) return;
      const currIdx = this.invalidGroupList.indexOf(this.activeGroupIndex);
      this.activeGroupIndex = this.invalidGroupList[currIdx - 1];
      this.focusMode = "voucher";
    },
    goNextInvalid() {
      if (!this.hasNextInvalid) return;
      let currIdx = this.invalidGroupList.indexOf(this.activeGroupIndex);
      if (currIdx === -1) currIdx = -1;
      this.activeGroupIndex = this.invalidGroupList[currIdx + 1];
      this.focusMode = "voucher";
    },
    handleGlobalKeyDown(e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        this.focusMode = "voucher";
        return;
      }
      if (e.key === "ArrowRight") {
        e.preventDefault();
        this.focusMode = "attach";
        return;
      }
      if (this.focusMode === "voucher") {
        const currPos = this.groupIdList.indexOf(this.activeGroupIndex);
        if (e.key === "ArrowDown") {
          e.preventDefault();
          if (currPos < this.groupIdList.length - 1) {
            this.activeGroupIndex = this.groupIdList[currPos + 1];
          }
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          if (currPos > 0) {
            this.activeGroupIndex = this.groupIdList[currPos - 1];
          }
        }
      } else if (this.focusMode === "attach") {
        this.handleKeyDown(e);
      }
    },
    handleKeyDown(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.prevMenu();
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.nextMenu();
      }
    },
    isGroupFirstRow(row) {
      const group = this.currentVoucherGroup;
      if (!group || group.length === 0) return false;
      return row === group[0];
    },
    numFormat(val) {
      if (!val) return "";
      return Number(val).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    buildGroupIndex() {
      const list = Array.isArray(this.voucherDetails) ? [...this.voucherDetails] : [];
      if (!list.length) {
        this.voucherTableData = [];
        this.activeGroupIndex = 0;
        return;
      }
      let groupIndex = 0;
      const noticeMap = new Map();
      const djIdMap = new Map();
      list.forEach(item => {
        const noticeNo = item.noticeNo;
        const djId = item.djId;
        if (noticeNo !== null && noticeNo !== undefined && noticeNo !== "") {
          if (noticeMap.has(noticeNo)) {
            item.groupIndex = noticeMap.get(noticeNo);
          } else {
            noticeMap.set(noticeNo, groupIndex);
            item.groupIndex = groupIndex;
            groupIndex++;
          }
        } else {
          if (djIdMap.has(djId)) {
            item.groupIndex = djIdMap.get(djId);
          } else {
            djIdMap.set(djId, groupIndex);
            item.groupIndex = groupIndex;
            groupIndex++;
          }
        }
      });
      this.voucherTableData = list;
      this.activeGroupIndex = this.voucherTableData[0]?.groupIndex ?? 0;
    },
    loadList() {
      const list = this.currentRawAttach;
      this.dataList = [];
      this.selectedIndex = 0;
      if (!list || list.length === 0) {
        this.selectedMenu = { title: "", key: "", type: "pdf", icon: "fa fa-file-pdf-o", url: "" };
        return;
      }
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.name.indexOf("回单") !== -1) continue;
        const menu = {
          title: item.name,
          key: item.uid,
          type: "pdf",
          icon: "fa fa-file-pdf-o",
          url: ""
        };
        switch (item.type) {
          case "application/pdf":
            menu.icon = "fa fa-file-pdf-o";
            menu.type = "pdf";
            break;
          case "image/jpeg":
          case "image/png":
          case "image/bmp":
          case "image/gif":
            menu.icon = "fa fa-file-image-o";
            menu.type = "img";
            break;
          case "text/plain":
            menu.icon = "fa fa-file-text-o";
            menu.type = "txt";
            break;
          case "application/msword":
          case "application/vnd.ms-excel":
            menu.icon = "fa fa-file-excel-o";
            menu.type = "excel";
            break;
          case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            menu.icon = "fa fa-file-word-o";
            menu.type = "word";
            break;
          case "application/vnd.ms-powerpoint":
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            menu.icon = "fa fa-file-powerpoint-o";
            menu.type = "ppt";
            break;
          case "application/x-zip-compressed":
            menu.icon = "fa fa-file-zip-o";
            menu.type = "zip";
            break;
          default:
            menu.icon = "fa fa-file-pdf-o";
            menu.type = "pdf";
        }
        if (item.isExternalLink) {
          menu.url = item.name.indexOf("审批") !== -1 ? item.withBankUrl : item.url;
        } else {
          menu.url = "/api" + item.url + "?name=" + item.name;
        }
        if (i === 0) this.selectedMenu = menu;
        this.dataList.push(menu);
      }
    },
    menuClick(data, index) {
      this.focusMode = "attach";
      this.selectedMenu = data;
      this.selectedIndex = index;
    },
    prevMenu() {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.selectedMenu = this.dataList[this.selectedIndex];
        this.$nextTick(() => this.scrollToSelected());
      }
    },
    nextMenu() {
      if (this.selectedIndex < this.dataList.length - 1) {
        this.selectedIndex++;
        this.selectedMenu = this.dataList[this.selectedIndex];
        this.$nextTick(() => this.scrollToSelected());
      }
    },
    scrollToSelected() {
      if (this.selectedEl) {
        this.selectedEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },
    onVoucherRowClick(row) {
      this.focusMode = "voucher";
      this.activeGroupIndex = row.groupIndex;
    },
    scrollVoucherToView() {
      const wrap = this.$refs.tableWrapRef;
      if (!wrap) return;
      const rows = Array.from(wrap.querySelectorAll(".active-voucher-group"));
      if (!rows || rows.length === 0) return;
      const firstRow = rows[0];
      const lastRow = rows[rows.length - 1];
      const wrapRect = wrap.getBoundingClientRect();
      const firstRect = firstRow.getBoundingClientRect();
      const lastRect = lastRow.getBoundingClientRect();
      const headerHeight = 34;
      const firstTop = firstRect.top - wrapRect.top + wrap.scrollTop;
      const lastBottom = lastRect.bottom - wrapRect.top + wrap.scrollTop;
      const viewTop = wrap.scrollTop + headerHeight;
      const viewBottom = wrap.scrollTop + wrap.clientHeight;
      if (firstTop < viewTop) {
        wrap.scrollTop = firstTop - headerHeight;
      } else if (lastBottom > viewBottom) {
        wrap.scrollTop = lastBottom - wrap.clientHeight;
      }
    }
  }
};
</script>

<style lang="less">
.menu-custom {
  .h-menu {
    &-show {
      color: #48576a;
      position: relative;
      &:hover {
        color: #20a0ff;
      }
    }
    &-li {
      &-selected {
        font-weight: bold;
        color: #20a0ff;
      }
    }
  }
}
.com-frame {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  outline: none;
}
.inner-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.left-frame {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  width: 640px;
  border-right:1px solid #f0f0f0;
  display:flex;
  flex-direction:column;
}
.table-caption{
  height:40px;
  line-height:40px;
  padding:0 10px;
  font-weight:bold;
  border-bottom:1px solid #eee;
  flex-shrink: 0;
}
.table-wrap{
  flex:1;
  overflow:auto;
}
.voucher-table{
  width:100%;
  border-collapse: collapse;
  font-size:13px;
}
.voucher-table .col-icon{
  width:32px;
}
.icon-cell{
  padding-left:6px;
}
.voucher-table thead th {
  position: sticky;
  top:0;
  background:#fafafa;
  z-index: 10;
  height:34px;
}
.voucher-table th,
.voucher-table td{
  border:1px solid #ebeef5;
  padding:8px 6px;
}
.text-right{
  text-align:right;
}
.text-center{
  text-align:center;
}
.voucher-table tbody tr.active-voucher-group td {
  background-color: #fff9cc;
  font-weight: bold;
}
.mid-frame {
  position: absolute;
  left: 640px;
  top: 0;
  bottom: 0;
  width: 320px;
  overflow: hidden;
  z-index: 2;
  border-right:1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
}
.panel-title {
  height:40px;
  line-height:40px;
  padding:0 10px;
  font-weight:bold;
  border-bottom:1px solid #eee;
  flex-shrink: 0;
}
.attach-bottom-btn-wrap{
  flex-shrink:0;
  padding:10px;
  border-top:1px solid #eee;
  display:flex;
  flex-direction: column;
  gap:8px;
  box-sizing: border-box;

  .btn-item{
    width:100%;
  }
  .btn-item button{
    width:100%;
  }
}
.right-frame {
  position: absolute;
  left: 960px;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 0 5px 0;
  overflow: auto;
  z-index: 1;
}
.tag-active {
  margin-left:10px;
  font-size:12px;
  color:#409eff;
}
.validate-tag{
  display:inline-block;
  padding:2px 6px;
  border-radius:3px;
  font-size:12px;
  color:#fff;
}
.tag-pass{
  background:#67c23a;
}
.tag-fail{
  background:#f56c6c;
}
.validate-empty{
  color:#999;
}
</style>
